<p-toast />
<p-confirmDialog />

<lib-card>
  <ng-container title>Relazione di Gestione</ng-container>
  <ng-container subtitle>
    @if (permissions.canEditTechnicalOffer()) {
      Scarica il documento, scrivi la premessa, correggi i dati generali e ricarica il file qui sotto.
    } @else {
      La premessa della relazione di gestione caricata da chi compila l'offerta tecnica.
    }
  </ng-container>

  <ng-container actions>
    @if (capabilities.canDownloadTemplate && permissions.canEditTechnicalOffer()) {
      <p-button
        label="Scarica documento"
        icon="pi pi-download"
        severity="secondary"
        size="small"
        [loading]="downloading()"
        [disabled]="downloading()"
        (onClick)="downloadTemplate()"
      />
    }
  </ng-container>

  <ng-container content>
    <div class="flex flex-col gap-4 pt-4">
      @if (permissions.canEditTechnicalOffer()) {
      <p class="text-sm leading-relaxed text-slate-600">
        Il documento scaricato contiene già l'intera offerta tecnica. Puoi
        modificare il titolo, i dati generali (Procedura e Candidato) e
        scrivere la premessa; la parte finale del documento, con criteri e
        risposte, è bloccata e viene rigenerata automaticamente in fase di
        export: non serve modificarla. Ricarica qui il file una volta
        compilato.
      </p>
      <p class="text-sm leading-relaxed text-slate-600">
        <strong>Importante:</strong> modifica il documento solo con
        <strong>Microsoft Word</strong>. Altri programmi (LibreOffice Writer,
        Google Docs, Pages, convertitori online) rimuovono la protezione della
        sezione bloccata: in quel caso il caricamento verrà rifiutato e dovrai
        scaricare di nuovo il documento.
      </p>
      }

      @if (premessaResource.isLoading()) {
        <div class="flex items-center gap-2 text-sm text-slate-400">
          <i class="pi pi-spin pi-spinner"></i>
          Verifica dello stato della premessa in corso...
        </div>
      } @else if (premessaResource.value()?.uploaded) {
        <div
          class="flex items-center justify-between gap-3 rounded-2xl border border-green-200 bg-green-50 p-4"
        >
          <div class="flex min-w-0 flex-col">
            <span class="truncate font-semibold text-green-800">
              {{ premessaResource.value()?.fileName }}
            </span>
            @if (premessaResource.value()?.uploadedAt) {
              <span class="text-sm text-green-700">
                Caricata il
                {{ premessaResource.value()?.uploadedAt | date: 'dd/MM/yyyy HH:mm' }}
              </span>
            }
          </div>
          @if (permissions.canEditTechnicalOffer()) {
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [text]="true"
              [loading]="deleting()"
              [disabled]="deleting()"
              pTooltip="Elimina premessa"
              (onClick)="confirmDelete()"
            />
          }
        </div>
      } @else {
        <div
          class="flex items-center gap-2 rounded-2xl border border-gray-200 bg-slate-50 p-4 text-sm text-slate-500"
        >
          <i class="pi pi-info-circle"></i>
          Nessuna premessa caricata.
        </div>
      }

      @if (permissions.canEditTechnicalOffer()) {
        <div>
          <input
            type="file"
            #fileInput
            accept=".docx"
            hidden
            (change)="onFilePicked($event, fileInput)"
          />
          <p-button
            [label]="
              premessaResource.value()?.uploaded
                ? 'Sostituisci premessa'
                : 'Carica premessa compilata'
            "
            icon="pi pi-upload"
            severity="secondary"
            [loading]="uploading()"
            [disabled]="uploading()"
            (onClick)="fileInput.click()"
          />
        </div>
      }
    </div>
  </ng-container>
</lib-card>
